module.exports = __webpack_public_path__ + "media/images/mobile/Mask Group 12-21e74b8ecba3ee41cbaa45767f10125d.png";